import { useEffect, useMemo, useState } from "react";

import workTimeList from "../data/workTimeList";
import { calculateNetMinutes, diffMinutes, minutesToHM } from "../utils/timeUtils";

export const DEFAULT_MOBILE_START_TIME = "08:00";
export const DEFAULT_MOBILE_FINISH_TIME = "17:00";
export const DEFAULT_MOBILE_WORK_TIME = `${DEFAULT_MOBILE_START_TIME}~${DEFAULT_MOBILE_FINISH_TIME}`;

const getDefaultTime = (shift) => shift === "야간"
  ? workTimeList.find((time) => time.shift === "야간")
  : { startTime: DEFAULT_MOBILE_START_TIME, finishTime: DEFAULT_MOBILE_FINISH_TIME };

export default function useOptionWorkTime(isMobile) {
  const [workTime, setWorkTime] = useState("");
  const [startTime, setStartTime] = useState("");
  const [finishTime, setFinishTime] = useState("");
  const [baseShift, setBaseShift] = useState("주간");

  const filteredWorkTimeList = useMemo(
    () => workTimeList.filter((time) => time.shift === baseShift),
    [baseShift]
  );

  useEffect(() => {
    if (!isMobile) return;

    const defaults = getDefaultTime(baseShift);
    setStartTime((prev) => prev || defaults.startTime);
    setFinishTime((prev) => prev || defaults.finishTime);
    setWorkTime((prev) => prev || `${defaults.startTime}~${defaults.finishTime}`);
  }, [isMobile, baseShift]);

  const baseWorkMinutes = useMemo(() => {
    if (!startTime || !finishTime) return 0;
    return calculateNetMinutes(startTime, finishTime);
  }, [startTime, finishTime]);

  const handleShiftChange = (shift) => {
    if (shift === baseShift) return;

    setBaseShift(shift);
    if (isMobile) {
      const defaults = getDefaultTime(shift);
      setWorkTime(`${defaults.startTime}~${defaults.finishTime}`);
      setStartTime(defaults.startTime);
      setFinishTime(defaults.finishTime);
      return;
    }

    setWorkTime("");
    setStartTime("");
    setFinishTime("");
  };

  const handleSelectWorkTime = (start, finish) => {
    setStartTime(start);
    setFinishTime(finish);
    setWorkTime(`${start}~${finish}`);
  };

  const handleStartTimeChange = (value) => {
    setStartTime(value);
    setWorkTime(`${value}~${finishTime || DEFAULT_MOBILE_FINISH_TIME}`);
  };

  const handleFinishTimeChange = (value) => {
    setFinishTime(value);
    setWorkTime(`${startTime || DEFAULT_MOBILE_START_TIME}~${value}`);
  };

  const resetWorkTime = () => {
    const defaults = getDefaultTime(baseShift);
    setWorkTime(isMobile ? `${defaults.startTime}~${defaults.finishTime}` : "");
    setStartTime(isMobile ? defaults.startTime : "");
    setFinishTime(isMobile ? defaults.finishTime : "");
  };

  return {
    baseShift,
    baseWorkMinutes,
    filteredWorkTimeList,
    finishTime,
    handleFinishTimeChange,
    handleSelectWorkTime,
    handleShiftChange,
    handleStartTimeChange,
    resetWorkTime,
    startTime,
    workTime,
  };
}

export const minutesToWorkTimeLabel = minutesToHM;
export const getWorkTimeDiffMinutes = diffMinutes;
